<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FDzcGP/tc-custom/9781504087742.jpg?1721057644818" alt="This image is the cover for the book Against the Rules"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Against the Rules
      </h1>
      <p class="bookDescription body article font2">
        <b>“Readers who like their romances fueled with plenty of red-hot sexual chemistry . . . will love this early work,” from a <i>New York Times</i>–bestselling author (<i>Booklist</i>).</b><br/>  <br/> When Cathryn Donohue-Ashe returns to her Texas hometown, she wants nothing to do with the ranch she inherited—or the rugged foreman in charge. Rule Jackson may have been her first love, the man who brutally broke her heart, but he’s also the reason she plans on hightailing back to the life she has made for herself in Chicago. But once she encounters Rule again, she can’t deny the strong stir of desire she still feels. And there’s no mistaking the glimmer of heat in his eyes . . .<br/>  <br/> When Rule was a younger man, Cat’s father saved him from the collision course he was on. Then Rule paid him back by claiming his innocent daughter—and letting her walk away. Now Rule owes it to the memory of the Donohue patriarch to make sure Cat finds the happiness she deserves, the life she was meant to live: on the ranch that is her birthright, with Rule by her side . . . 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Linda Howard
      </h2>
      
      <p class="authorDescription body article">Linda Howard is&#160;<I>the</I>&#160;<I>New York Times</I>&ndash;bestselling romance and suspense author of&#160;<I>Up Close</I>&#160;<I>and</I>&#160;<I>Dangerous</I>,&#160;<I>Drop Dead Gorgeous</I>,&#160;<I>Cover of Night</I>,&#160;<I>Killing Time</I>,&#160;<I>To Die For</I>,&#160;<I>Kiss Me While I Sleep</I>,&#160;<I>Cry No More</I>, and&#160;<I>Dying to Please</I>. She is a charter member of Romance Writers of America and in 2005 was awarded their Lifetime Achievement Award. Howard lives in Gadsden, Alabama, with her husband and two golden retrievers. She has three grown stepchildren and three grandchildren.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e1292252